import { ParametrosDeliveryInicial } from "../models/parametrosDeliveryModel"
import type { ParametrosDeliveryModel } from "../models/parametrosDeliveryModel"
import { ParametrosDeliveryActionsTypes } from "./parametrosDeliveryActions"
import type { ParametrosDeliveryActionModel } from "./parametrosDeliveryActions"

export function parametrosDeliveryReducer(
    state: ParametrosDeliveryModel,
    action: ParametrosDeliveryActionModel
): ParametrosDeliveryModel {
    switch (action.type) {
        case ParametrosDeliveryActionsTypes.CARREGAR:
            return action.payload

        case ParametrosDeliveryActionsTypes.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            }

        case ParametrosDeliveryActionsTypes.RESETAR:
            return ParametrosDeliveryInicial

        default:
            return state
    }
}
